module.exports = __webpack_public_path__ + "static/img/youzan.c9b5d12.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/youzan.jpeg
// module id = n1ax
// module chunks = 1